export default "__VITE_ASSET__Vq_Owaku__"